import { render, staticRenderFns } from "./CCourseCard.vue?vue&type=template&id=7c51bb22&scoped=true&"
import script from "./CCourseCard.vue?vue&type=script&lang=js&"
export * from "./CCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./CCourseCard.vue?vue&type=style&index=0&id=7c51bb22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c51bb22",
  null
  
)

export default component.exports